import { useState } from "react";
import { Copy } from "../../assets/svg/copy.icon";
import "./index.scss";

interface Props {
    value: string;
    tooltip?: string;
}
export function CopyTag({ value, tooltip }: Props) {
    const [copied, setCopied] = useState(false);
    return value != "" ? (
        <div
            className="copy-tag"
            title={copied ? "Copied to clipboard!" : tooltip}
        >
            <div className="limit-text">{value}</div>
            <button
                onClick={e => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(value);
                    setCopied(true);
                    setTimeout(() => setCopied(false), 5000);
                }}
                className="copy-icon"
            >
                <i>
                    <Copy style={{ height: "10px" }} />
                </i>
            </button>
        </div>
    ) : (
        <></>
    );
}
